// react-slick ships CommonJS (its dist sets `__esModule` and `exports.default`).
// Vite 8 changed CJS default-import interop, so `import Slider from "react-slick"`
// can resolve to the module namespace object instead of the component, crashing
// render with React error #130 ("element type is invalid ... got: object").
// Same class of bug as ./Lottie; normalise the interop in one place.
import SliderImport from "react-slick";

const Slider = ((SliderImport as unknown as { default?: unknown }).default ??
  SliderImport) as typeof SliderImport;

export default Slider;
